"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const types = require("./types-ti");
function listProps(interfaceName) {
  return types[interfaceName].props.map(p => p.name);
}
exports.default = listProps;